import { useNavigate } from 'react-router-dom';
import { Descope } from '@descope/react-sdk';
import { getAppConfig } from '@/app/config';
import { Flex, Loader, Paper } from '@mantine/core';
import styles from './RequireAuth.module.css';
import { useState } from 'react';

const AcceptInvite = () => {
  const navigate = useNavigate();
  const { descopeAcceptInviteFlowId } = getAppConfig();
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div className={styles.authBackground}>
      <div className={styles.authContainer}>
        {isLoading && (
          <Paper shadow="md" p="xl" radius="md" withBorder w={560} h={450}>
            <Flex justify="center" align="center" h="100%">
              <Loader />
            </Flex>
          </Paper>
        )}
        <div style={{ display: !isLoading ? 'block' : 'none' }}>
          <Descope
            flowId={descopeAcceptInviteFlowId}
            onReady={() => setIsLoading(false)}
            onSuccess={() => navigate('/')}
            styleId="overstory"
          />
        </div>
      </div>
    </div>
  );
};

export default AcceptInvite;
